import { AsyncPipe } from '@angular/common';
import { Component, inject, signal, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { Observable, shareReplay } from 'rxjs';
import { Directory } from '../../../../../shared/models/directory';
import { DirectoryService } from '../../../../../shared/services/directory.service';
import { ExportPromptsComponent } from './export-prompts/export-prompts.component';
import { ImportPromptsComponent } from './import-prompts/import-prompts.component';

@Component({
    selector: 'app-prompt-import-export-dialog',
    templateUrl: './prompt-import-export-dialog.component.html',
    imports: [
        MatTabsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        ImportPromptsComponent,
        ExportPromptsComponent,
        AsyncPipe,
    ],
})
export class PromptImportExportDialogComponent {
    private readonly directoryService = inject(DirectoryService);

    protected readonly selectedTabIndex = signal(0);

    protected readonly importComponent = viewChild(ImportPromptsComponent);
    protected readonly exportComponent = viewChild(ExportPromptsComponent);

    protected readonly directories$: Observable<Directory[]>;

    constructor() {
        this.directories$ = this.directoryService.getAllWritableDirectoriesForCurrentUser().pipe(shareReplay({ bufferSize: 1, refCount: true }));
    }
}
